/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React from 'react'
import styles from './Avatar.module.scss'
import {PlayerColor} from '@colonist/game-states'
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {GameColor} from '../../../../../code/client/shared/scripts/GameColor'
import {getImagePath, getLobbyImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {Sprites} from '../../../../../code/client/shared/scripts/ui_game/UIGameImageDictionary'
import {ColonistMembershipProduct} from '../../../../../code/shared/store/ColonistMembershipProduct'

export interface AvatarProps {
    image?: LobbyImage | undefined
    hideBackground?: boolean
    color?: PlayerColor
    className?: string
    showPlusIcon?: boolean
    membership?: ColonistMembershipType | undefined
    onClick?: VoidFunction
    profilePictureUrl?: string | undefined
}

export const Avatar = ({
    className = '',
    image,
    color,
    hideBackground,
    showPlusIcon,
    membership,
    onClick,
    profilePictureUrl,
}: AvatarProps) => (
    <div
        className={clsx(styles.container, {[styles.hideBackground]: hideBackground}, className)}
        onClick={onClick}
        style={(color != null) && !profilePictureUrl
            ? {
                background: `radial-gradient(circle, white, ${GameColor.getLighterGradientOfPlayerColor(color)} 35%)`,
                border: `1px solid ${GameColor.getLighterGradientOfPlayerColor(color)}`,
            }
            : {}
        }
    >
        {showPlusIcon && (
            <div className={clsx(styles.icon, styles.plus)}>
                <img className={styles.image} src={getImagePath(`${Sprites.icon_add_friend}.svg`)} />
            </div>
        )}

        {(membership != null) && (
            <a
                className={clsx(styles.icon, styles.membership)}
                href='/store#membership'
                rel="noreferrer"
                target='_blank'
            >
                <img className={styles.image} src={getLobbyImagePath(ColonistMembershipProduct.getMembershipProduct(membership).lobbyImage)} />
            </a>
        )}
        {(image != null) && !profilePictureUrl && (
            <img
                className={styles.avatarImage}
                src={getLobbyImagePath(image)}
            />
        )}
        {(profilePictureUrl != null) && (
            <img
                className={clsx(styles.avatarImage, styles.profilePicture)}
                src={profilePictureUrl}
            />
        )}
    </div>
)
